import { ActionIcon, Box, CopyButton, Group, Text, Tooltip } from "@mantine/core"
import { CheckIcon, CopyIcon } from "@phosphor-icons/react"
import { useTranslation } from "react-i18next"
import detail from "../../pages/sales-invoice/details.module.css"
import classes from "./BuyerInvoiceDetails.module.css"

// The supplier's account the buyer pays into -- the one thing a buyer needs to
// read off this page before paying, so it gets a full-width row with a copy button.
// Rendered as one item of the info card's <dl>.
export function ReceivingAccount({ account }: { account: any }) {
  const { t } = useTranslation("invoice")

  return (
    <Box className={`${detail.metaItem} ${classes.metaWide}`}>
      <Text component="dt" className={detail.metaDt}>
        {t("form.receiverAccLabel")}
      </Text>
      <Box component="dd" className={detail.metaDd}>
        {account?.number ? (
          <>
            <Group gap="xs" wrap="nowrap" miw={0}>
              <Text component="span" className={classes.accountNumber}>
                {account.number}
              </Text>
              {account.bankName && (
                <Text component="span" className={classes.bankChip}>
                  {account.bankName}
                </Text>
              )}
              <CopyButton value={`${account.number}`} timeout={1500}>
                {({ copied, copy }) => (
                  <Tooltip label={copied ? t("detail.actions.copied") : t("detail.actions.copy")} withArrow>
                    <ActionIcon
                      variant="subtle"
                      color={copied ? "green" : "gray"}
                      size="sm"
                      onClick={copy}
                      aria-label={t("detail.actions.copy")}
                    >
                      {copied ? <CheckIcon size={14} weight="bold" /> : <CopyIcon size={14} />}
                    </ActionIcon>
                  </Tooltip>
                )}
              </CopyButton>
            </Group>
            {account.name && <Text className={classes.accountName}>{account.name}</Text>}
          </>
        ) : (
          <Text component="span" className={detail.metaDdMuted}>
            {t("form.noBankAccount")}
          </Text>
        )}
      </Box>
    </Box>
  )
}
